export const presetProgressions = [
  {
    id: "progressao1",
    label: " 1",
    chords: [
      { grau: 2, rotulo: "IIm7", chordType: "m7", left: ["1", "b7"], right: ["1", "b3", "5", "b7"] },
      { grau: 5, rotulo: "V7", chordType: "7", left: ["1", "3"], right: ["5", "b7", "1", "3"] },
      { grau: 1, rotulo: "I7M", chordType: "maj7", left: ["1", "7M"], right: ["1", "3", "5", "7M"] },
    ],
  },
  {
    id: "progressao2",
    label: " 2",
    chords: [
      { grau: 2, rotulo: "IIm7", chordType: "m7", left: ["1", "b7"], right: ["9", "b3", "5"] },
      { grau: 5, rotulo: "V7", chordType: "7", left: ["1", "3"], right: ["13", "b7", "9"] },
      { grau: 1, rotulo: "I7M", chordType: "maj7", left: ["1", "7M"], right: ["9", "3", "5"] },
    ],
  },
  {
    id: "progressao3",
    label: " 3",
    chords: [
      { grau: 2, rotulo: "IIm7", chordType: "m7", left: ["1", "b7"], right: ["b3", "5", "b7", "9"] },
      { grau: 5, rotulo: "V7", chordType: "7", left: ["1", "3"], right: ["b7", "9", "3", "13"] },
      { grau: 1, rotulo: "I7M", chordType: "maj7", left: ["1", "7M"], right: ["3", "5", "7M", "9"] },
    ],
  },
  {
    id: "progressao4",
    label: " 4",
    chords: [
      { grau: 2, rotulo: "IIm7", chordType: "m7", left: ["1", "b7"], right: ["b3", "5", "b7", "9"] },
      { grau: 5, rotulo: "V7", chordType: "7", left: ["1", "3"], right: ["b7", "b9", "3", "13"] },
      { grau: 1, rotulo: "I7M", chordType: "maj7", left: ["1", "7M"], right: ["3", "5", "7M", "9"] },
    ],
  },
  {
    id: "progressao5",
    label: " 5",
    chords: [
      { grau: 2, rotulo: "IIm7", chordType: "m7", left: ["1", "b7"], right: ["b3", "5", "b7", "9"] },
      { grau: 5, rotulo: "V7", chordType: "7", left: ["1", "3"], right: ["b7", "9", "#11", "13"] },
      { grau: 1, rotulo: "I7M", chordType: "maj7", left: ["1", "7M"], right: ["3", "5", "7M", "9"] },
    ],
  },
  {
    id: "progressao6",
    label: " 6",
    chords: [
      { grau: 2, rotulo: "IIm7", chordType: "m7", left: ["1", "b7"], right: ["b3", "5", "b7", "9"] },
      { grau: 5, rotulo: "V7", chordType: "7", left: ["1", "3"], right: ["b7", "b9", "#11", "13"] },
      { grau: 1, rotulo: "I7M", chordType: "maj7", left: ["1", "7M"], right: ["3", "5", "7M", "9"] },
    ],
  },
  {
    id: "progressao7",
    label: " 7",
    chords: [
      { grau: 2, rotulo: "IIm7", chordType: "m7", left: ["1", "7"], right: ["9", "b3", "5", "b7"] },
      { grau: 5, rotulo: "V7", chordType: "7", left: ["1", "3"], right: ["b13", "b7", "b9", "3"] },
      { grau: 1, rotulo: "I7M", chordType: "maj7", left: ["1", "7M"], right: ["9", "3", "5", "7M"] },
    ],
  },
  {
    id: "progressao8",
    label: " 8",
    chords: [
      { grau: 2, rotulo: "IIm7", chordType: "m7", left: ["1", "11"], right: ["b7", "b3", "5"] },
      { grau: 5, rotulo: "V7", chordType: "7", left: ["1", "7"], right: ["3", "13", "b9", "3"] },
      { grau: 1, rotulo: "I6", chordType: "6", left: ["1", "3", "6"], right: ["9", "5", "1"] },
    ],
  },
  {
    id: "progressao9",
    label: " 9",
    chords: [
      { grau: 2, rotulo: "IIm7", chordType: "m7", left: ["1", "b3"], right: ["5", "b7", "9"] },
      { grau: 5, rotulo: "V7", chordType: "7", left: ["1", "b7"], right: ["b9", "3", "#11", "13"] },
      { grau: 1, rotulo: "I7M", chordType: "maj7", left: ["1", "3"], right: ["5", "6", "7M", "9"] },
    ],
  },
  {
    id: "progressao10",
    label: "10",
    chords: [
      { grau: 2, rotulo: "IIm7", chordType: "m7", left: ["1", "b3"], right: ["5", "b7", "9"] },
      { grau: 5, rotulo: "V7", chordType: "7", left: ["1", "b7"], right: ["3", "b13", "1", "#9"] },
      { grau: 1, rotulo: "I7M", chordType: "maj7", left: ["1", "3"], right: ["6", "7M", "9", "5"] },
    ],
  },
   {
    id: "progressao11",
    label: "11",
    chords: [
      { grau: 2, rotulo: "IIm7", chordType: "m7", left: ["1", "b7"], right: ["b3", "5", "9"] },
      { grau: 5, rotulo: "V7", chordType: "7", left: ["1", "3"], right: ["b7", "b9", "b13"] },
      { grau: 1, rotulo: "I7M", chordType: "maj7", left: ["1", "7M"], right: ["3", "5", "9"] },
    ],
  },
  {
    id: "progressao12",
    label: "12",
    chords: [
      { grau: 2, rotulo: "IIm7", chordType: "m7", left: ["1", "11"], right: ["b7","9", "b3", "5"] },
      { grau: 5, rotulo: "V7", chordType: "7", left: ["1", "b7"], right: ["3", "#11", "13", "1"] },
      { grau: 1, rotulo: "I6", chordType: "maj7", left: ["1", "3"], right: ["6", "7M", "9", "5"] },
    ],
  },
  {
    id: "progressao13",
    label: "13",
    chords: [
      { grau: 2, rotulo: "IIm7", chordType: "m7", left: ["1"], right: ["b7", "9","b3", "5"] },
      { grau: 5, rotulo: "V7", chordType: "7", left: ["1"], right: ["3", "b13", "b7", "#9"] },
      { grau: 1, rotulo: "I7M", chordType: "maj7", left: ["1"], right: ["7M", "9", "3", "5"] },
    ],
  },
  {
    id: "progressao14",
    label: "14",
    chords: [
      { grau: 2, rotulo: "IIm7", chordType: "m7", left: ["1", "b3"], right: ["5", "b7", "9", "11"] },
      { grau: 5, rotulo: "V7", chordType: "7", left: ["1", "b7"], right: ["3", "#11", "b7", "b9"] },
      { grau: 1, rotulo: "I7M", chordType: "maj7", left: ["1", "3"], right: ["7M", "9", "#11", "13"] },
    ],
  },
   {
    id: "progressao15",
    label: "15",
    chords: [
      { grau: 2, rotulo: "IIm7", chordType: "m7", left: ["1", "11"], right: ["b7","b3", "5"] },
      { grau: 5, rotulo: "V7", chordType: "7", left: ["1", "b7"], right: ["3", "b13", "b9"] },
      { grau: 1, rotulo: "I6", chordType: "6", left: ["1", "3"], right: ["6", "9", "5"] },
    ],
  },
   {
    id: "progressao16",
    label: "16",
    chords: [
      { grau: 2, rotulo: "IIm7", chordType: "m7", left: ["1", "11"], right: ["b7","b3", "5", "b7"] },
      { grau: 5, rotulo: "V7", chordType: "7", left: ["1", "b7"], right: ["3", "13", "b9", "3"] },
      { grau: 1, rotulo: "I6", chordType: "6", left: ["1", "3", "6"], right: ["9", "5", "7M"] },
    ],
  },
   {
    id: "progressao17",
    label: "17",
    chords: [
      { grau: 2, rotulo: "IIm7", chordType: "m7", left: ["1", "b3"], right: ["5", "b7", "9"] },
      { grau: 5, rotulo: "V7", chordType: "7", left: ["1", "b7"], right: ["9", "3","13"] },
      { grau: 1, rotulo: "I7M", chordType: "maj7", left: ["1", "3"], right: ["6", "7M", "9"] },
    ],
  },
];
